import { type RecommendedObject, userDocumentsQuery } from '@atlassian/search-client';

export const fetchUserDocuments = async (
	cloudId: string,
	userId: string,
	aggAbsoluteUrl: string | undefined,
) => {
	return await userDocumentsQuery({
		variables: {
			userId,
			tenantId: cloudId,
			caller: 'quick-find',
			maxNumberOfResults: 100,
		},
		aggAbsoluteUrl,
	}).then((response) => {
		const recommendedObjects = response.data?.smarts?.recommendedObject || [];
		return recommendedObjects.filter(({ object }) => Boolean(object)).map(mapEssentialData);
	});
};

export const mapEssentialData = (result: RecommendedObject) => {
	return {
		id: result.id,
		title: result?.object?.title || '',
		data: result,
		type: 'user-document' as const,
	};
};
